import OrchestratorAPI from './common.js';
import { type JobValidation } from '../models/encounter.js';

interface FindAllOptions {
  jobId?: number;
  valid?: boolean;
}

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/job-validations';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options: FindAllOptions = {}): Promise<JobValidation[]> {
    const url = this.constructPath('/', options);
    const { jobValidations } = await this.common.getJSON(url);
    return jobValidations.map(this.deserialize);
  }
}
